import { LOGIN_PAGE, SIGNUP_PAGE, TRIAL_PAGE, TRIAL_SIGNUP_PAGE, TRIAL_SIGNUP_ENTROPY_PAGE, SET_PASSWORD_PAGE, MARKETPLACE_REDIRECT_PAGE } from "@/router/paths";
import { sessionManager } from "./sessionManager";
const LOGIN_PATH = "/login";
const AUTH_FLASH_KEY = "aws-portal.auth.flash";
const FLASH_TTL_MS = 60_000;
const STRICT_REPLAY_TTL_MS = 1_000;
// not trigger redirect for these, MFA should not trigger 401s
const PUBLIC_PAGES = [
    LOGIN_PAGE,
    SIGNUP_PAGE,
    TRIAL_PAGE,
    TRIAL_SIGNUP_PAGE,
    TRIAL_SIGNUP_ENTROPY_PAGE,
    SET_PASSWORD_PAGE,
    MARKETPLACE_REDIRECT_PAGE
];
let isRedirectingToLogin = false;
let strictReplayFlashMessage = null;
function setAuthFlashMessage(message) {
    if (typeof window === "undefined") {
        return;
    }
    const payload = {
        message,
        createdAt: Date.now()
    };
    sessionStorage.setItem(AUTH_FLASH_KEY, JSON.stringify(payload));
    strictReplayFlashMessage = null;
}
function readAuthFlashMessage() {
    if (typeof window === "undefined") {
        return "";
    }
    const rawPayload = sessionStorage.getItem(AUTH_FLASH_KEY);
    if (!rawPayload) {
        if (strictReplayFlashMessage && Date.now() - strictReplayFlashMessage.createdAt <= STRICT_REPLAY_TTL_MS) {
            const replayMessage = strictReplayFlashMessage.message;
            strictReplayFlashMessage = null;
            return replayMessage;
        }
        strictReplayFlashMessage = null;
        return "";
    }
    sessionStorage.removeItem(AUTH_FLASH_KEY);
    try {
        const parsedPayload = JSON.parse(rawPayload);
        const isValidPayload = typeof parsedPayload.message === "string" && typeof parsedPayload.createdAt === "number";
        if (!isValidPayload) {
            strictReplayFlashMessage = null;
            return "";
        }
        const isExpired = Date.now() - parsedPayload.createdAt > FLASH_TTL_MS;
        if (isExpired) {
            strictReplayFlashMessage = null;
            return "";
        }
        strictReplayFlashMessage = {
            message: parsedPayload.message,
            createdAt: Date.now()
        };
        return parsedPayload.message;
    } catch  {
        strictReplayFlashMessage = null;
        return "";
    }
}
export function consumeAuthFlashMessage() {
    return readAuthFlashMessage();
}
export function redirectToLogin({ message } = {}) {
    if (typeof window === "undefined") {
        return;
    }
    sessionManager.stopTracking();
    localStorage.removeItem("auth-token-storage");
    const isPublicPage = PUBLIC_PAGES.includes(window.location.pathname);
    if (!isRedirectingToLogin && !isPublicPage) {
        if (message) {
            setAuthFlashMessage(message);
        }
        isRedirectingToLogin = true;
        window.location.assign(LOGIN_PATH);
    }
}
